import { I18n } from "@aws-amplify/core";
import { Grid } from "@material-ui/core";
import React from "react";
import colors from "../../../assets/style/colors";
import CustomButton from "../../Common/CustomButton";
import FoldableSection from "../../Common/FoldableSection";
import { withStyles } from "@material-ui/core";
import TimeSlotsSettings from "./TimeSlotsSettings";
import update from "immutability-helper";
import { get } from "lodash";
import images from "../../../assets/img/images";
import VisitRestrictionsSettings from "./VisitRestrictionsSettings";

const styles = (theme) => ({
  dataColumn: {
    [theme.breakpoints.down("lg")]: {
      width: "calc(100% - 200px)",
    },
    [theme.breakpoints.up("lg")]: {
      width: "930px",
    },
  },
  actionColumn: {
    minWidth: "200px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "flex-start",
  },
  foldableSection: {
    backgroundColor: colors.lightGrey,
    height: "40px",
    display: "flex",
    alignItems: "center",
    paddingLeft: "16px",
    marginBottom: "16px",
  },
});

const SchedulerSettings = (props) => {
  const { classes } = props;
  //const [scheduleTypes, setScheduleTypes] = React.useState();
  const [editMode, setEditMode] = React.useState(false);
  const [formValues, setFormValues] = React.useState();

  const initFormValues = () => {
    setFormValues({
      timeSlots: {},
      visitRestrictions: {},
    });
  };

  const startEdit = () => {
    setEditMode(true);
    initFormValues();
  };

  const handleChange = (key, value) => {
    setFormValues(
      update(formValues, {
        [key]: { $set: value },
      })
    );
  };

  return (
    <Grid container wrap="nowrap">
      <Grid item className={classes.dataColumn}>
        <FoldableSection
          title={I18n.get("scheduler_timeSlots")}
          className={classes.foldableSection}
        >
          <TimeSlotsSettings
            editMode={editMode}
            formValues={get(formValues, ["timeSlots"])}
            handleChange={handleChange}
          />
        </FoldableSection>
        <FoldableSection
          title={I18n.get("scheduler_visitRestrictions")}
          className={classes.foldableSection}
        >
          <VisitRestrictionsSettings
            editMode={editMode}
            formValues={get(formValues, ["visitRestrictions"])}
            handleChange={handleChange}
          />
        </FoldableSection>
      </Grid>
      <Grid item xs className={classes.actionColumn}>
        {editMode ? (
          <>
            <CustomButton
              color="primary"
              onClick={() => setEditMode(false)}
              style={{ marginRight: "20px" }}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
            <CustomButton color="primary" variant="contained">
              {I18n.get("site_confirm")}
            </CustomButton>
          </>
        ) : (
          <img
            src={images.editIconColored}
            alt="edit"
            width="18px"
            style={{
              cursor: "pointer",
            }}
            onClick={startEdit}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(SchedulerSettings);
